// Формула <text>/<hint> возвращает строку с кавычками JS-литерала и экранированными переводами строк.
export const postProcessTextDisplay = (v: string) => v.replace(/\'/g, '').replace(/\\n/g, '\n');
